import dayjs from 'dayjs'

class SmartDiagnoseAlertDataUploadModel {
  constructor(model) {
    this.model = model;
  }

  get updateTime() {
    return placeholderText(this.model.gmtCreate)
  }

  get errorLog() {
    if (this.isSucceed) {
      return placeholderText(this.model.errorLog)
    } else {
      return `数据上传失败(${placeholderText(this.model.errorLog)})`
    }
    
  }

  get isSucceed(){
    return this.model.errorLog && this.model.errorLog == '数据上传成功'
  }

  get recoverInfo() {
    if (this.isSucceed) {
      return undefined
    } else {
      return `uid:${placeholderText(this.model.userId)}\n sn:${placeholderText(this.model.ringSn)}\n url:${this.model.logContent}`
    }
  }

  get isSyncPeriodLog() { 
    return this.model.logContent.includes('监测时段已同步')
  }

  get periodStartTime() { 
    const logContent = this.model.logContent;
    if (!logContent || !logContent.includes('监测时段已同步')) {
      return '';
    }
    const periodPart = logContent.split('监测时段已同步')[1].trim().replace(/[）)]/g, '');
    const startTimeStr = periodPart.split('-')[0];
    const gmtCreate = this.model.gmtCreate;
    if (!gmtCreate || !startTimeStr) {
      return '';
    }
    
    const gmtCreateDate = dayjs(gmtCreate);
    const [hours, minutes] = startTimeStr.split(':').map(Number);
    let periodStart = gmtCreateDate.hour(hours).minute(minutes).second(0);
    
    // 只有当开始时间早于gmtCreate时间，并且结束时间也早于gmtCreate时间时，才设置为下一天
    const endTimeStr = periodPart.split('-')[1];
    if (endTimeStr) {
      const [endHours, endMinutes] = endTimeStr.split(':').map(Number);
      let periodEnd = gmtCreateDate.hour(endHours).minute(endMinutes).second(0);
      
      if (periodStart.isBefore(gmtCreateDate) && periodEnd.isBefore(gmtCreateDate)) {
        periodStart = periodStart.add(1, 'day');
      }
    } else {
      // 如果没有结束时间，则使用原来的逻辑
      if (periodStart.isBefore(gmtCreateDate)) {
        periodStart = periodStart.add(1, 'day');
      }
    }
    
    return periodStart.format('YYYY-MM-DD HH:mm');
  }

  get periodEndTime() { 
    const logContent = this.model.logContent;
    if (!logContent || !logContent.includes('监测时段已同步')) {
      return '';
    }
    const periodPart = logContent.split('监测时段已同步')[1].trim().replace(/[）)]/g, '');
    const endTimeStr = periodPart.split('-')[1];
    const startTime = this.periodStartTime;
    if (!startTime || !endTimeStr) {
      return '';
    }
    
    const [hours, minutes] = endTimeStr.split(':').map(Number);
    let periodEnd = dayjs(startTime).hour(hours).minute(minutes).second(0);
    
    // 处理结束时间早于开始时间的情况（跨天）
    if (periodEnd.isBefore(dayjs(startTime))) {
      periodEnd = periodEnd.add(1, 'day');
    }
    
    return periodEnd.format('YYYY-MM-DD HH:mm');
  }
}

export { SmartDiagnoseAlertDataUploadModel }